import { useMemo } from 'react';
import {
  getActiveAndVisibleControlUnitsByIdFilter,
  getControlUnitsActiveByIdFilter,
} from '../selectors';
import ControlUnitAPI from '../api/ControlUnitAPI';
import { isNotNullOrUndefined } from '../../../util/types/Array';
import { COMMANDER_VOLATILE_DATA_POOLING_INTERVAL } from '../../commander/api/Constants';
import { skipToken } from '@reduxjs/toolkit/query';

interface UseControlUnitsByIdProps {
  deviceId?: string;
  hideCommander?: boolean;
  // skipFetch?: boolean;
  refresh?: boolean;
}
/**
 * Get and fetch control unit from specified device
 * @param deviceId
 * @returns [controlUnits, loading, error]
 * 
 * @usage
´´´ts
const [controlUnits, loading, error] = useControlUnitsById({
  deviceId: "UUUID_DEVICE",
  onlyVisibleControlUnits: true,
  refresh: true,
})
´´´
 */
export function useControlUnitsById(props: UseControlUnitsByIdProps) {
  const {
    deviceId,
    hideCommander: hideCommander = false,
    refresh = false,
  } = props;
  const controlUnitFilter = useMemo(
    () =>
      hideCommander
        ? getActiveAndVisibleControlUnitsByIdFilter
        : getControlUnitsActiveByIdFilter,
    [hideCommander]
  );

  const response = ControlUnitAPI.useGetControlUnitByIdQuery(
    deviceId ?? skipToken,
    {
      skip: !deviceId,
      pollingInterval: refresh
        ? COMMANDER_VOLATILE_DATA_POOLING_INTERVAL
        : undefined,
      selectFromResult: (response) => {
        const controlUnits = response?.data?.ids
          .map((id) => response?.data?.entities[id])
          .filter(isNotNullOrUndefined)
          .filter(controlUnitFilter);
        return {
          ...response,
          data: controlUnits,
        };
      },
    }
  );
  return response;
}
